export default function initialize(recommandation) {
  if (!recommandation || !recommandation.data || !recommandation.data.pointDeVentes.length) {
    return;
  }
  if (Array.isArray(recommandation.data.pointDeVentes[0].panneaux)) {
    recommandation.data.pointDeVentes[0].panneaux.forEach((el, i) => {
      el.select = false;
      el.num = i + 1;
    });
  }
  recommandation.data.pointDeVentes[0].urlPdv = recommandation.data.urlPdv;
}
